/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useEffect, useState } from "react";
// import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { injectIntl, intlShape } from "react-intl";
import { Button, Loader, Card, CardSection } from "cxa-components";
import ClaimStepper from "./ClaimStepper";
import withMatchMediaProps from "@hocs/with-match-media-props";
import {
  uploadReceipt,
  setRejectedReceipt,
  skipOCRProcess,
  getClaimDetail,
} from "../../actions/claimActionsPP";
import messages from "components/messagesDescription";
import ReceiptUploader from "./widgets/receipt-uploader";
import { ACCEPT_FILES, MAX_FILE_SIZE } from "../constants";
import ReceiptProcessingLoader from "./ReceiptProcessingLoader";
import ClaimSubmissionFormPP from "./ClaimSubmissionFormPP";
import ClaimSubmissionGuideline from "./widgets/ClaimSubmissionGuideline";
import ClaimRHS from "./ClaimRHS";
import PropTypes from "prop-types";

const EditClaimPagePP = props => {
  const {
    match: { params },
    intl,
  } = props;
  const data = useSelector(state => state.claimsPP);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    setIsLoading(true);
    dispatch(getClaimDetail(params.claimId, params.selectedDelegator)).finally(() => {
      setIsLoading(false);
    });
    //Scroll to the top of the page
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  let initialValues = {
    claimObjectId: params.claimId,
    receipt: data.receipt ? [data.receipt] : [],
  };
  if (!data.claimDetail && data.claimItem && data.claimItem.formFields) {
    initialValues.claimItemName = data.claimItem.claimFormTitle;
    const claimantField = data.claimItem.formFields.find(x => x.name === "claimantName");
    if (claimantField) {
      initialValues.claimantName =
        data.selectedClaimant ||
        (claimantField.items && claimantField.items.length > 0 && claimantField.items[0].value);
    }
    const receiptCurrencyField = data.claimItem.formFields.find(x => x.name === "receiptCurrency");
    if (receiptCurrencyField) {
      initialValues.receiptCurrency =
        receiptCurrencyField.items &&
        receiptCurrencyField.items.length > 0 &&
        receiptCurrencyField.items[0].value;
    }
  } else if (data.claimDetail && data.claimItem && data.claimItem.formFields) {
    data.claimItem.formFields.forEach(ele => {
      initialValues[ele.name] = data.claimDetail[ele.name];
    });
    const attachments = data.claimDetail.attachments || [];
    initialValues.receipt = attachments.filter(x => x.field == "Receipt");
    initialValues.benefitPeriod = data.claimDetail.benefitPeriod;
    initialValues.claimTypeId = data.claimDetail.claimTypeId;
    initialValues.postalCode = data.claimDetail.postalCode;
    initialValues.providerName = data.claimDetail.providerName;
    initialValues.consultationFee = data.claimDetail.consultationFee;
  }
  if (!initialValues.benefitPeriod) {
    initialValues.benefitPeriod = data.selectedPlanYear;
  }

  // Auto fill up OCR values.
  if (
    !data.claimDetail &&
    data.claimItem &&
    data.ocrValues &&
    data.ocrValues.status === "success" &&
    data.ocrValues.fields
  ) {
    data.ocrValues.fields.forEach((field, _) => {
      const item = data.claimItem.formFields.find(x => x.name === field.name);
      if (field.name === "receiptAmount") {
        const foreignReceiptAmount = data.claimItem.formFields.find(
          x => x.name === "foreignReceiptAmount"
        );
        const fieldName = (foreignReceiptAmount && foreignReceiptAmount.name) || field.name;
        initialValues[fieldName] = field.value;
      } else if (field.name === "claimantName") {
        if (Array.isArray(item.items) && item.items.find(i => i.label == field.value)) {
          const fieldName = (item && item.name) || field.name;
          initialValues[fieldName] = initialValues.claimantName;
        }
      } else if (field.name === "provider") {
        if (item.dataType === "Autocomplete") {
          const providerValue =
            Array.isArray(item.items) && item.items.find(x => x.value === field.value);
          const isProviderObject = typeof providerValue === "object" && providerValue !== null;
          initialValues.provider = isProviderObject ? providerValue.value : "";
        } else {
          initialValues.provider = field.value;
        }
      } else {
        const fieldName = (item && item.name) || field.name;
        initialValues[fieldName] = field.value;
      }
    });
  }

  const skipOCR = () => {
    dispatch(skipOCRProcess());
  };

  const massageDataToDeductPendingForNonDraftClaim = () => {
    const { claimAccounts, claimDetail } = data;

    // Return early if no accounts exist or the claim is in "Draft" status
    if (!claimAccounts.length || !claimDetail || claimDetail.status === "Draft") {
      return claimAccounts;
    }

    // Clone the first account and adjust its pending receipt amount
    const [firstAccount, ...remainingAccounts] = claimAccounts;
    const updatedFirstAccount = {
      ...firstAccount,
      pendingReceiptAmount: firstAccount.pendingReceiptAmount - claimDetail.receiptAmount,
    };

    // Combine the updated first account with the remaining accounts
    return [updatedFirstAccount, ...remainingAccounts];
  };

  const claimAccounts = massageDataToDeductPendingForNonDraftClaim();

  return (
    <Fragment>
      <ClaimStepper index={1} />
      {!data.claimItem || isLoading ? (
        <Loader />
      ) : (
        <div>
          <h3>
            <span className="claim-header">
              {props.intl.formatMessage(messages.claims.addReceipt)}
            </span>
          </h3>
          <div className="claim-form-container">
            <div className="cxa-grid__item--nine">
              {data.claimDetail ? (
                <Card>
                  <ClaimSubmissionFormPP {...props} initialValues={initialValues} />
                </Card>
              ) : (
                <Card>
                  <CardSection>
                    {!data.receipt && !data.ocrValues && (
                      <ClaimSubmissionGuideline
                        title={intl.formatMessage(messages.claims.claimSubmissionGuideline)}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data.claimItem.claimSubmissionGuideline,
                          }}
                        />
                      </ClaimSubmissionGuideline>
                    )}
                  </CardSection>
                  <CardSection>
                    {!data.receipt && (
                      <Fragment>
                        <div className="upload-receipt-container">
                          {!data.isCameraStarted && (
                            <ReceiptUploader
                              className="receipt-uploader"
                              accept={ACCEPT_FILES}
                              maxSize={MAX_FILE_SIZE}
                              onDrop={(files, rejectedFiles) => {
                                files.map(file => {
                                  dispatch(uploadReceipt(file, params.selectedDelegator));
                                });
                                Array.isArray(rejectedFiles) &&
                                  rejectedFiles.length > 0 &&
                                  dispatch(setRejectedReceipt(rejectedFiles));
                              }}
                            />
                          )}
                        </div>
                        {data.rejectedReceipt && data.rejectedReceipt.length > 0 && (
                          <div className="field__error">
                            <p>
                              <strong>
                                {intl.formatMessage(messages.uploadInvalidFileDescription)}
                              </strong>
                            </p>
                            <p>
                              <strong>
                                {intl.formatMessage(messages.uploadImageLimitationDescription)}
                              </strong>
                            </p>
                          </div>
                        )}
                        <div
                          style={{
                            display: "flex",
                            margin: "10px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Button type="button" secondary disabled>
                            {intl.formatMessage(messages.claims.manualUploadReceipt)}
                          </Button>
                        </div>
                      </Fragment>
                    )}
                    {data.receipt &&
                      (!data.ocrValues || data.ocrValues.status == "pending") &&
                      !data.skipOCR && (
                        <div>
                          <ReceiptProcessingLoader receipt={data.receipt} intl={intl} {...props} />
                          <div
                            style={{
                              display: "flex",
                              margin: "10px",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Button type="button" secondary onClick={skipOCR}>
                              {intl.formatMessage(messages.claims.manualUploadReceipt)}
                            </Button>
                          </div>
                        </div>
                      )}
                    {data.receipt &&
                      ((data.ocrValues &&
                        (data.ocrValues.status == "success" || data.ocrValues.status == "error")) ||
                        data.skipOCR) && (
                        <ClaimSubmissionFormPP {...props} initialValues={initialValues} />
                      )}
                  </CardSection>
                </Card>
              )}
            </div>
            <div className="cxa-grid__item--three  claim-panel-mobile-container">
              <ClaimRHS claimAccounts={claimAccounts} {...props} />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

EditClaimPagePP.propTypes = {
  intl: intlShape.isRequired,
  match: PropTypes.shape({
    params: PropTypes.object,
  }),
};

export default injectIntl(
  withMatchMediaProps({
    isNarrowScreen: {
      maxWidth: 680,
    },
  })(EditClaimPagePP)
);



// WEBPACK FOOTER //
// ./components/claim/EditClaimPagePP.js